/** Drag & drop utilities for sidebar folder tree */

import type { FolderTree } from '../hooks/use-folders'

/**
 * Check if `targetId` is a descendant of `dragId` in the folder tree.
 * Used to prevent dropping a parent folder into its own child (cycle).
 */
export function isDescendant(
  dragId: string,
  targetId: string,
  folders: FolderTree[],
): boolean {
  if (dragId === targetId) return true // self is "descendant" of self
  const map = buildFolderMap(folders)
  const dragNode = map.get(dragId)
  if (!dragNode) return false
  return hasDescendant(dragNode, targetId)
}

function hasDescendant(node: FolderTree, targetId: string): boolean {
  for (const child of node.children) {
    if (child.id === targetId) return true
    if (hasDescendant(child, targetId)) return true
  }
  return false
}

/** Build a flat lookup map from nested folder tree */
function buildFolderMap(folders: FolderTree[]): Map<string, FolderTree> {
  const map = new Map<string, FolderTree>()
  function walk(nodes: FolderTree[]) {
    for (const node of nodes) {
      map.set(node.id, node)
      walk(node.children)
    }
  }
  walk(folders)
  return map
}
